import type {NavigationGuardReturn} from 'vue-router';
import {usePermissionStore} from '@/stores/permissionStore';
import {useToast} from '@/shared/components/toast/useToast';
import {translate} from '@/shared/mixins/translation';
import type {PermissionName} from '@/api/models/permissions/permissionName';

declare module 'vue-router' {
    // eslint-disable-next-line @typescript-eslint/consistent-type-definitions -- module augmentation requires an interface
    interface RouteMeta {
        permission?: PermissionName;
    }
}

// Runs beside the role key, so a route carrying both needs both, as the backend does.
export async function handlePermissionMeta(
    permission: PermissionName
): Promise<NavigationGuardReturn> {
    const permissionStore = usePermissionStore();
    await permissionStore.isReady();

    if (permissionStore.holdsDuringRollout(permission)) {
        return;
    }

    useToast().error(translate('app.errors.not_authorized'));

    return {name: 'Home'};
}
